import React from 'react'
import { IMAGE_URL } from '../Constants/constants';

const dealBadge = (deal) => {
    if (deal.discountType === 2 && deal.discount) return `${deal.discount}% OFF`;
    if (deal.discountType === 3) return 'BOGO';
    if (deal.discount) return `$${deal.discount}`;
    return 'DEAL';
};

export default function BusinessDeals({ seller }) {
    const deals = seller.deals || [];

    if (deals.length === 0) {
        return (
            <div className="bp-panel bp-tab-empty">
                <span className="bp-empty-glyph" aria-hidden="true">🏷️</span>
                <h3>No active deals</h3>
                <p className="bp-dim">This shop hasn't posted any offers yet — check back soon.</p>
            </div>
        );
    }

    return (
        <div className="bp-panel" style={{ padding: '26px' }}>
            <div className="bp-deals-grid">
                {deals.map((deal, i) => (
                    <article className="bp-deal-card" key={deal._id || i}>
                        <div className="bp-deal-top">
                            {deal.image
                                ? <img alt="" src={IMAGE_URL + deal.image} />
                                : <div className="bp-deal-fallback" aria-hidden="true">🏷️</div>}
                            <span className="bp-deal-badge">{dealBadge(deal)}</span>
                        </div>
                        <div className="bp-deal-body">
                            <h4>{deal.title}</h4>
                            {deal.subTitle && <span className="bp-dim">{deal.subTitle}</span>}
                            {deal.description && <p>{deal.description}</p>}
                            {deal.type && <span className="bp-shop-chip">{deal.type}</span>}
                        </div>
                    </article>
                ))}
            </div>
        </div>
    )
}
